import React from 'react';

import { Input } from './Input';
import { Inputs } from './Inputs';
import { Select } from './Select';
import { Options } from './Options';
import { Checkbox } from './Checkbox';
import { SliderOnly } from './SliderOnly';
import { AditionalItemsMapper } from './types';
import { InputAndInput } from './InputAndInput';
import { RadioAndInput } from './RadioAndInput';
import { SelectAndInput } from './SelectAndInput';
import { SliderAndInput } from './SliderAndInput';
import { SelectAndSlider } from './SelectAndSlider';
import { SelectAndSubSelect } from './SelectAndSubSelect';
import { SelectInputAndInput } from './SelectInputAndInput';
import { InputAndInputPartial } from './InputAndInputPartial';
import { SelectRadioAndInputs } from './SelectRadioAndInputs';
import { RadioAndRadioAndRadio } from './RadioAndRadioAndRadio';
import { SelectDependentInputs } from './SelectDependentInputs';
import { AdditionalItem, AdditionalItemsResults } from '@/hooks';
import { AdditionalItemResult } from '@/hooks/useGetCustomReportResultStepKeyDefaultData';

const INPUT_AND_INPUT_TYPE = 'input_and_input';
const PARTIAL_INPUT_AND_INPUT_ITEMS = ['shelves_and_flow_rack_assessment'];

function isPartialInputAndInput(additionalItem: AdditionalItem): boolean {
	return (
		additionalItem.additional_item_type.type === INPUT_AND_INPUT_TYPE &&
		PARTIAL_INPUT_AND_INPUT_ITEMS.includes(additionalItem.name)
	);
}

interface AdditionalComponentsProps {
	additionalItems: AdditionalItem[];
	defaultData: AdditionalItemResult[];
}

export function AdditionalComponents({
	additionalItems,
	defaultData
}: Readonly<AdditionalComponentsProps>): JSX.Element {
	const components: AditionalItemsMapper = {
		inputs: Inputs,
		input_only: Input,
		select: Select,
		radio_options: Options,
		slider_only: SliderOnly,
		input_and_input: InputAndInput,
		select_and_input: SelectAndInput,
		slider_and_input: SliderAndInput,
		select_and_slider: SelectAndSlider,
		select_and_sub_select: SelectAndSubSelect,
		select_input_and_input: SelectInputAndInput,
		select_radio_and_inputs: SelectRadioAndInputs,
		radio_and_radio_and_radio: RadioAndRadioAndRadio,
		select_dependent_inputs: SelectDependentInputs,
		radio_and_input: RadioAndInput,
		checkbox: Checkbox
	};

	return (
		<>
			{additionalItems.map((additionalItem) => {
				let AditionalItem = components[additionalItem.additional_item_type.type];

				if (isPartialInputAndInput(additionalItem)) {
					AditionalItem = InputAndInputPartial;
				}

				const defaultItemResult: AdditionalItemsResults[] =
					additionalItem.results?.length > 0
						? additionalItem.results
						: defaultData.filter((f) => f.additional_item_id === additionalItem.id);

				if (!AditionalItem) {
					return <></>;
				}

				return (
					<AditionalItem
						key={additionalItem.id}
						additionalItem={{
							...additionalItem,
							results: defaultItemResult
						}}
					/>
				);
			})}
		</>
	);
}
